var map = {
	"./accordion-cmp-extended.vue": "e3ec",
	"./aspect-ratio-box-cmp.vue": "b23f",
	"./banner-cmp.vue": "aebf",
	"./beautiful-date.vue": "d234",
	"./breadcrumbs-cmp.vue": "df41",
	"./card-cmp.vue": "78d6",
	"./card-product-cmp.vue": "3ba7",
	"./card-product-spec-item-cmp.vue": "1e96",
	"./card-product-specs-cmp.vue": "8eba",
	"./carousel-brands-brand-cmp.vue": "7a4f",
	"./carousel-brands-cmp.vue": "a5a8",
	"./carousel-certifications-cmp.vue": "ab9d",
	"./carousel-images-cmp.vue": "4de5",
	"./carousel-posts-cmp.vue": "97dc",
	"./carousel-product-banners-cmp.vue": "0e79",
	"./carousel-product-cards-cmp.vue": "2e71",
	"./chef-contest-form.vue": "6886",
	"./chefs-note-banner-cmp.vue": "a08a",
	"./colored-box.vue": "9998",
	"./configurations-component/global-config.vue": "f8da",
	"./configurations-component/local-config.vue": "efc1",
	"./configurations-component/news-and-media-config.vue": "853e",
	"./configurations-component/products-config.vue": "8776",
	"./configurations-component/recipes-config.vue": "5e40",
	"./configurations-component/services-config.vue": "d325",
	"./contact-form/contact-form-back-cta-cmp.vue": "624c",
	"./contact-form/contact-form-cmp.vue": "9afd",
	"./contact-form/contact-form-fiscal-info-cmp.vue": "1834",
	"./contact-form/contact-form-message-info-cmp.vue": "20d4",
	"./contact-form/contact-form-personal-info-cmp.vue": "ef72",
	"./contact-form/contact-form-stepper-cmp.vue": "e01c",
	"./cooking-tips-best-practices-detail-page.vue": "cd79",
	"./cooking-tips-best-practices-page.vue": "3f5e",
	"./cooking-tips-materials-page.vue": "3045",
	"./cooking-tips-static-cmp.vue": "d7e3",
	"./cooking-tips-videos-page.vue": "59b4",
	"./cta-box-cmp.vue": "9602",
	"./cta-button-cmp-extended.vue": "b354",
	"./dropdown-cmp-extended.vue": "ef7f",
	"./event-info-cmp.vue": "ee2c",
	"./face-to-face-cmp.vue": "fa65",
	"./figure-card-cmp.vue": "d4d8",
	"./focus-items-cmp.vue": "5813",
	"./focus-items-nutrition-allergens-cmp.vue": "f15b",
	"./focus-items-tab-content-cmp.vue": "940b",
	"./footer-banner.vue": "fa76",
	"./footer-cmp.vue": "27fd",
	"./gigya/gigya-config.vue": "3f65",
	"./gigya/gigya-gtm-handler.vue": "d561",
	"./gigya/gigya-initializer.vue": "74f4",
	"./gigya/gigya-menu-item.vue": "17e7",
	"./gigya/gigya-screen.vue": "b112",
	"./grid-column-cmp.vue": "ca62",
	"./grid-container-cmp.vue": "44db",
	"./grid-row-cmp.vue": "8d21",
	"./guidelines-cmp.vue": "7b86",
	"./header-cmp.vue": "79a2",
	"./hero-al-bronzo-cmp.vue": "2473",
	"./hero-cmp.vue": "2cf6",
	"./highlighted-image-cmp.vue": "396b",
	"./highlighted-video-cmp.vue": "1e54",
	"./icon-text-info-cmp.vue": "a79a",
	"./image-cmp.vue": "def1",
	"./info-dropdown-cmp.vue": "678c",
	"./ingredients-steps-list-cmp.vue": "a162",
	"./input-checkbox-cmp-extended.vue": "e486",
	"./input-file-cmp-extended.vue": "dad5",
	"./input-radio-cmp-extended.vue": "35bb",
	"./input-text-cmp-extended.vue": "be01",
	"./js-loader.vue": "df91",
	"./landing-banner-cmp.vue": "0b68",
	"./landing-banner-content-cmp.vue": "0c48",
	"./language-modal-cmp.vue": "cc07",
	"./loading-cmp.vue": "5641",
	"./main-image-cmp.vue": "53f0",
	"./media-download-cmp.vue": "ac77",
	"./media-player-cmp.vue": "de3e",
	"./menu-item-cmp.vue": "105a",
	"./menu-subitem-cmp.vue": "80f2",
	"./modal-cmp.vue": "e7d2",
	"./my-simple-example-page.vue": "0ad6",
	"./my-spa-example-page.vue": "2d3b",
	"./news-and-media-app-hook/news-and-media-detail-page.vue": "1f36",
	"./news-and-media-app-hook/news-and-media-list-page.vue": "d5d1",
	"./news-and-media-app-hook/news-and-media-list-tab-page.vue": "2e8c",
	"./news-and-media-app-hook/news-and-media-page.vue": "b370",
	"./newsletter-form-cmp.vue": "981b",
	"./one-trust.vue": "4152",
	"./pagination-cmp.vue": "9d4e",
	"./pasta-parallax-wrapper-cmp.vue": "1a92",
	"./picture-cmp.vue": "1781",
	"./podcast-link-cmp.vue": "8530",
	"./product-modal-cmp.vue": "b5be",
	"./products-app-hook/first-level-category-page.vue": "f4c2",
	"./products-app-hook/product-detail-page.vue": "f6f2",
	"./products-app-hook/second-level-category-page.vue": "a542",
	"./profitability-calculator-cmp.vue": "ce69",
	"./profitability-calculator-wrapper-cmp.vue": "30b5",
	"./quote-cmp.vue": "a795",
	"./recaptcha-cmp.vue": "2fe8",
	"./recipes-app-hook/nutrition-modal-cmp.vue": "770b",
	"./recipes-app-hook/recipe-detail-page.vue": "4a22",
	"./recipes-app-hook/recipes-footer-cmp.vue": "008b",
	"./recipes-app-hook/recipes-hub-page.vue": "2421",
	"./recipes-app-hook/recipes-list-page.vue": "74d6",
	"./scroll-x-navbar-cmp.vue": "1d42",
	"./search-modal-cmp.vue": "f602",
	"./select-cmp-extended.vue": "42c3",
	"./side-by-side-cmp.vue": "6e06",
	"./simple-card-cmp.vue": "1bc1",
	"./slider-cmp-extended.vue": "2b0b",
	"./social-share-cmp.vue": "3ad1",
	"./social-share-item.vue": "9f65",
	"./step-card-cmp.vue": "f894",
	"./submit-cmp-extended.vue": "c8f7",
	"./sustainability-banner-cmp.vue": "450c",
	"./svg-icons-cmp.vue": "da2d",
	"./table-cell-cmp.vue": "34ae",
	"./table-cmp.vue": "d5f4",
	"./table-row-cmp.vue": "6420",
	"./tabs-cmp.vue": "9e7b",
	"./tag-cmp.vue": "058e",
	"./text-with-cmp.vue": "e151",
	"./textarea-cmp-extended.vue": "b93f",
	"./title-format-al-bronzo-cmp.vue": "de49",
	"./title-format-cmp.vue": "a551",
	"./title-separator-cmp.vue": "c3d2",
	"./title-text-cmp.vue": "bd0c",
	"./wysiwyg-cmp.vue": "10cd",
	"./youtube-media-player-cmp-extended.vue": "6c5f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9f89";